import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const KEY = "peppa_cart";

export function CartProvider({ children }) {
    const [items, setItems] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem(KEY) || "[]");
        } catch {
            return [];
        }
    });

    useEffect(() => {
        localStorage.setItem(KEY, JSON.stringify(items));
    }, [items]);

    function add(product, qty = 1) {
        setItems((prev) => {
            const existing = prev.find((i) => i.product_id === product.id);
            if (existing) {
                return prev.map((i) =>
                    i.product_id === product.id ? { ...i, quantity: i.quantity + qty } : i
                );
            }
            return [
                ...prev,
                {
                    product_id: product.id,
                    name: product.name,
                    price: product.price,
                    quantity: qty,
                    image_url: product.image_url || "",
                    slug: product.slug,
                },
            ];
        });
    }

    function updateQty(productId, quantity) {
        setItems((prev) =>
            prev
                .map((i) => (i.product_id === productId ? { ...i, quantity: Math.max(1, quantity) } : i))
                .filter((i) => i.quantity > 0)
        );
    }

    function remove(productId) {
        setItems((prev) => prev.filter((i) => i.product_id !== productId));
    }

    function clear() {
        setItems([]);
    }

    const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
    const count = items.reduce((s, i) => s + i.quantity, 0);

    return (
        <CartCtx.Provider value={{ items, add, updateQty, remove, clear, subtotal, count }}>
            {children}
        </CartCtx.Provider>
    );
}

export function useCart() {
    return useContext(CartCtx);
}
